__turbopack_context__.v({
  "bodyText": "_1rH-Ya_bodyText",
  "copyBlock": "_1rH-Ya_copyBlock",
  "dharmaHeading": "_1rH-Ya_dharmaHeading",
  "dharmaTitleWrapper": "_1rH-Ya_dharmaTitleWrapper",
  "sectionBg": "_1rH-Ya_sectionBg",
  "sectionContent": "_1rH-Ya_sectionContent",
  "sectionWithBg": "_1rH-Ya_sectionWithBg",
  "srOnly": "_1rH-Ya_srOnly",
});
